import type { FolderAsset } from 'models';
import { useCallback, useMemo, useState } from 'react';

export const useAssetsFoldersParents = () => {
  const [parents, setParents] = useState<FolderAsset[]>([]);
  const lastParentFolder: FolderAsset | undefined = parents.at(-1);

  const addParentFolder = useCallback((folder: FolderAsset) => {
    setParents((previous) => {
      if (previous.some((parent) => parent.id === folder.id)) {
        return previous;
      }

      return [...previous, folder];
    });
  }, []);

  const navigateToParentFolder = useCallback((folder: FolderAsset) => {
    setParents((previous) => {
      const folderIndex = previous.findIndex((parent) => parent.id === folder.id);

      if (folderIndex === -1 || folderIndex === previous.length - 1) {
        return previous;
      }

      return previous.slice(0, folderIndex + 1);
    });
  }, []);

  const navigateToRoot = useCallback(() => {
    setParents([]);
  }, []);

  const removeLastParentFolder = useCallback(() => {
    setParents((previous) => previous.slice(0, -1));
  }, []);

  return useMemo(
    () => ({
      addParentFolder,
      lastParentFolder,
      navigateToParentFolder,
      navigateToRoot,
      parents,
      removeLastParentFolder,
    }),
    [addParentFolder, lastParentFolder, navigateToParentFolder, navigateToRoot, parents, removeLastParentFolder],
  );
};
